import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Linkedin, Mail, Link2 } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

function ShareButtons({ article }) {
  const url = window.location.href;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Lien copié !");
    } catch {
      toast.info("Copie impossible — copiez l'URL depuis la barre d'adresse.");
    }
  };
  const btn = { border: "1px solid var(--border)", color: "var(--ink)" };
  return (
    <div className="flex items-center gap-3" data-testid="share-buttons">
      <span className="overline" style={{ color: "var(--ink-2)" }}>Partager</span>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"
        className="p-2.5 hover:opacity-70 transition-opacity duration-150" style={btn} data-testid="share-linkedin" aria-label="Partager sur LinkedIn">
        <Linkedin size={17} />
      </a>
      <a href={`mailto:?subject=${encodeURIComponent(article.title)}&body=${encodeURIComponent(`À lire sur ALDOL-SOLUTIONS : ${article.title}\n${url}`)}`}
        className="p-2.5 hover:opacity-70 transition-opacity duration-150" style={btn} data-testid="share-email" aria-label="Partager par email">
        <Mail size={17} />
      </a>
      <button onClick={copy} className="p-2.5 hover:opacity-70 transition-opacity duration-150" style={btn} data-testid="share-copy" aria-label="Copier le lien">
        <Link2 size={17} />
      </button>
    </div>
  );
}

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setError(true));
  }, [slug]);

  if (error) return (
    <div className="pt-40 pb-40 text-center" data-testid="article-not-found">
      <p className="font-display text-3xl mb-6">Article introuvable</p>
      <Link to="/conseils" className="btn-primary px-6 py-3 font-semibold">Retour aux conseils</Link>
    </div>
  );
  if (!article) return <div className="pt-[148px] min-h-screen" />;

  return (
    <div className="pt-[148px]" data-testid="article-detail-page">
      <div className="max-w-[860px] mx-auto px-5 md:px-10 pt-10">
        <Link to="/conseils" className="link-hover inline-flex items-center gap-2 text-sm font-medium" data-testid="back-conseils">
          <ArrowLeft size={16} /> Retour aux conseils
        </Link>
      </div>
      <article className="max-w-[860px] mx-auto px-5 md:px-10 py-10 pb-24">
        <Reveal>
          <span className="overline" style={{ color: "var(--orange)" }}>{article.category}</span>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight leading-tight mt-4 mb-8">{article.title}</h1>
        </Reveal>
        <div className="overflow-hidden mb-10" style={{ border: "1px solid var(--border)" }}>
          <img src={article.image} alt={article.title} className="w-full h-[380px] object-cover" />
        </div>
        <div className="space-y-6 text-lg leading-relaxed" style={{ color: "var(--ink-2)" }}>
          {article.content.split("\n\n").map((p, i) => (<p key={i}>{p}</p>))}
        </div>
        <div className="mt-12 pt-8" style={{ borderTop: "1px solid var(--border)" }}>
          <ShareButtons article={article} />
        </div>
      </article>
    </div>
  );
}
